import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID?.trim();
const GSC_CONTENT = process.env.REACT_APP_GOOGLE_SITE_VERIFICATION?.trim();

function ensureGscMeta(content) {
  if (!content) return;
  let el = document.querySelector('meta[name="google-site-verification"]');
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('name', 'google-site-verification');
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function loadGtag(measurementId) {
  if (!measurementId || window.__rinkGtagLoaded) return;
  window.__rinkGtagLoaded = true;
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', measurementId, { send_page_view: false });

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`;
  document.head.appendChild(script);
}

function trackPageView(path) {
  if (!GA_ID || typeof window.gtag !== 'function') return;
  window.gtag('event', 'page_view', {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
}

/**
 * Injects Search Console verification + Google Analytics (GA4).
 * Set REACT_APP_GA_MEASUREMENT_ID (G-XXXXXXXX) and/or
 * REACT_APP_GOOGLE_SITE_VERIFICATION in frontend/.env, then rebuild.
 */
export default function AnalyticsBootstrap() {
  const location = useLocation();

  useEffect(() => {
    ensureGscMeta(GSC_CONTENT);
    loadGtag(GA_ID);
  }, []);

  useEffect(() => {
    const path = `${location.pathname}${location.search}`;
    trackPageView(path);
  }, [location.pathname, location.search]);

  return null;
}

export { GA_ID, GSC_CONTENT };
